import React, { useContext, useState, useEffect } from "react";
import { navigate } from "gatsby";
import { Box } from "@mui/material";
import { Download } from "./../../";
import { findQueryParameter, SiteContext } from "gatsby-frontend";

function DownloadPage() {
	const { location } = useContext(SiteContext);
	const [error, setError] = useState(null);
	const [uuid, setUuid] = useState(
		findQueryParameter(location.search, "media")
	);

	useEffect(() => {
		if (error === false) {
			let redir = location?.state?.referrer ? location.state.referrer : null;
			if (redir) {
				setTimeout(() => {
					navigate(redir);
				}, 1000);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [error]);

	return (
		<Box
			sx={(theme) => ({
				maxWidth: "480px",
				marginX: "auto",
				marginY: theme.spacing(4),
			})}
		>
			<Download id={uuid} setError={setError} />
		</Box>
	);
}

export default DownloadPage;
